import React, { useEffect, useState, useRef } from "react";
import { Upload, notification } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";

import { addeditdata } from "../../../controllers/cms/partners";
import { fetchIpAddress } from "../../../controllers/API";
import LoadingEffect from "../../../components/Loading/LoadingEffect";

const { Dragger } = Upload;

const UserListEditPage = () => {
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState({});
  const [ADDEDITDATA, setAddEditData] = useState(state ? state : {});
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  /*********************************************************
   *  This function is used to handle input change
   *********************************************************/
  const handleChange = (e) => {
    setAddEditData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    setError((prev) => ({
      ...prev,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is used to handle image upload and compression
   *********************************************************/
  const handleImageChange = async (info) => {
    const file = info.file.originFileObj || info.file;

    if (info.file.status === "removed") {
      return; // Ignore remove events
    }
    // Validate file type and size
    if (!file.type.startsWith("image/")) {
      setError((prev) => ({ ...prev, image: "Please upload a valid image file." }));
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setError((prev) => ({ ...prev, image: "Image must be smaller than 5MB." }));
      return;
    }

    // Compress the image
    const options = {
      maxSizeMB: 1, // Maximum size in MB after compression
      maxWidthOrHeight: 1024, // Maximum width or height
      useWebWorker: true, // Use web worker for better performance
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const newFile = {
        ...file,
        originFileObj: compressedFile, // Replace the original file with the compressed one
      };
      setImage([newFile]);
      setError((prev) => ({ ...prev, image: "" }));
    } catch (error) {
      console.error("Error compressing image:", error);
      setError((prev) => ({ ...prev, image: "Failed to compress image." }));
    }
  };
  const handleRemove = (file) => {
    setImage([]); // Clear the image
    // message.success("Image removed successfully!");
  };
  /*********************************************************
   *  This function is used to handle form submission
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const { _id } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("editId", _id);
      }

      if (image.length > 0) {
        form.append("image", image[0]?.originFileObj);
      }
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const options = {
          url: `cms/partners/addeditdata/${_id ? _id : ":editId"}`,
          postData: form,
        };
        const res = await addeditdata(options);

        if (res.status === true) {
          notification.success({
            message: "Data added.",
            description: `Data added successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/cms/partners");
        } else {
          notification.error({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.error({
          message: "Oops!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  /*********************************************************
   *  This function is used to validate form data
   *********************************************************/
  const validateFormData = (form) => {
    if (!ADDEDITDATA?._id && (!form.get("image") || form.get("image") == null)) {
      setError((prev) => ({ ...prev, image: "Image is required." }));
      return false;
    }
    return true;
  };

  /*********************************************************
   *  Scroll to the top and set document title
   *********************************************************/
  useEffect(() => {
    targetRef.current.scrollIntoView({ behavior: "smooth" });
    document.title = `KC High Super Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"} Partners`;
  }, [ADDEDITDATA]);

  return (
    <div ref={targetRef}>
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Partner
            </h5>
          </div>
          <Link to="/cms/partners">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="form-group">
                  <label htmlFor="exampleInputPassword1" className="all_section_for_label_main_class">
                    {!ADDEDITDATA?._id && <span style={{ color: "red" }}>*</span>}
                    Images
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount={1}
                    listType="picture-card"
                    onChange={handleImageChange}
                    fileList={image}
                    beforeUpload={() => false} // Prevent automatic upload
                    onRemove={handleRemove} 
                  >
                    <button type="button" className="about_us_dragger_file_button">
                      Upload file
                    </button>
                  </Dragger>
                  <p style={{ color: "blue" }} className="all_top_and_bottom_for_input_text">
                    *Note: Please select an image format (JPEG/JPG/PNG).
                  </p>
                  {error.image && <p style={{ color: "red" }}>{error.image}</p>}
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;